import { action } from 'satcheljs';

const onFeatureFlagsPaneOpened = action('ON_FEATURE_FLAG_PANES_OPENED');

export default onFeatureFlagsPaneOpened;
